if (!customElements.get('details-group')) {
  class DetailsGroup extends HTMLElement {

    constructor() {
      super();
      this.details = this.querySelector('[data-details-group]');
      this.details.addEventListener('toggle', this.onToggle.bind(this));
      this.innerDetails = this.querySelectorAll('[data-details-single]');
      this.innerDetails.forEach(el => el.addEventListener('toggle', this.onSingleToggle.bind(this)));
    }

    onToggle(e) {
      e.stopPropagation();
      if (!e.target.open) return;
      const dropdowns = document.querySelectorAll('[data-details-group][open]');
      Array.prototype.forEach.call(dropdowns, function (dropdown) {
        if (dropdown === e.target) return;
        dropdown.removeAttribute('open');
      });
      e.target.scrollIntoView({
        block: 'center'
      });
    }

    onSingleToggle(e) {
      e.stopPropagation();

      if (!e.target.open) return;
      const dropdowns = this.querySelectorAll('[data-details-single][open]');
      Array.prototype.forEach.call(dropdowns, function (dropdown) {
        if (dropdown === e.target) return;
        dropdown.removeAttribute('open');
      });
    }
    
  }
  customElements.define('details-group', DetailsGroup);
}